import { atom } from "recoil";
import crematoriumDetailType from "types/crematoriumDetailType";
// import jangjiDetailType from "types/jangjiDetailType";
import parlorDetailType from "types/parlorDetailType";

export const parlorDetailState = atom<parlorDetailType | undefined>({
  key: "parlorDetailState",
  default: undefined,
});

export const parlorDetailErrorState = atom<boolean>({
  key: "parlorDetailErrorState",
  default: false,
});

export const crematoriumDetailState = atom<crematoriumDetailType | undefined>({
  key: "crematoriumDetailState",
  default: undefined,
});

export const crematoriumDetailErrorState = atom<boolean>({
  key: "crematoriumDetailErrorState",
  default: false,
});

// export const jangjiDetailState = atom<jangjiDetailType | undefined>({
//   key: "jangjiDetailState",
//   default: undefined,
// });

// export const jangjiDetailErrorState = atom<boolean>({
//   key: "jangjiDetailErrorState",
//   default: false,
// });
